import { render } from "./notFound.vue?vue&type=template&id=0aa5be58&scoped=true"
import script from "./notFound.vue?vue&type=script&lang=js"
export * from "./notFound.vue?vue&type=script&lang=js"

import "./notFound.vue?vue&type=style&index=0&id=0aa5be58&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aa5be58"]])

export default __exports__